import {useEffect, useState} from "react";
import {toast} from "react-hot-toast";
import {UploadService} from "../../utils/UploadService";
import {CustomerService} from "./Service";
import {SettingService} from "../setting/Service";
import Select from 'react-select';
import {useParams} from "react-router-dom";
import {City, Country, State} from "country-state-city";

const UpdateCustomer = () => {
    const {id} = useParams();
    const [service] = useState(new CustomerService());
    const [settingService] = useState(new SettingService());
    const [uploadService] = useState(new UploadService());
    // General Details
    const [type, setType] = useState('Customer');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [whatsapp, setWhatsapp] = useState('');
    const [website, setWebsite] = useState('');
    const [profilePic, setProfilePic] = useState('');

    // Address
    const [shippingAddressName, setShippingAddressName] = useState('');
    const [shippingAddressLine1, setShippingAddressLine1] = useState('');
    const [shippingAddressLine2, setShippingAddressLine2] = useState('');
    const [shippingAddressCountry, setShippingAddressCountry] = useState<{ label: string, value: string } | null>(null);
    const [shippingAddressState, setShippingAddressState] = useState<{ label: string, value: string } | null>(null);
    const [shippingAddressCity, setShippingAddressCity] = useState<{ label: string, value: string } | null>(null);
    const [shippingAddressZipcode, setShippingAddressZipcode] = useState('');
    const [shippingAddressStateOptions, setShippingAddressStateOptions] = useState<{
        label: string,
        value: string
    }[]>([]);
    const [shippingAddressCityOptions, setShippingAddressCityOptions] = useState<{
        label: string,
        value: string
    }[]>([]);

    const [billingAddressName, setBillingAddressName] = useState('');
    const [billingAddressLine1, setBillingAddressLine1] = useState('');
    const [billingAddressLine2, setBillingAddressLine2] = useState('');
    const [billingAddressCountry, setBillingAddressCountry] = useState<{ label: string, value: string } | null>(null);
    const [billingAddressState, setBillingAddressState] = useState<{ label: string, value: string } | null>(null);
    const [billingAddressCity, setBillingAddressCity] = useState<{ label: string, value: string } | null>(null);
    const [billingAddressZipcode, setBillingAddressZipcode] = useState('');
    const [countryOptions, setCountryOptions] = useState<{ label: string, value: string }[]>([]);
    const [billingAddressStateOptions, setBillingAddressStateOptions] = useState<{
        label: string,
        value: string
    }[]>([]);
    const [billingAddressCityOptions, setBillingAddressCityOptions] = useState<{ label: string, value: string }[]>([]);

    // Bank
    const [bankName, setBankName] = useState('');
    const [bankBranch, setBankBranch] = useState('');
    const [bankAccountHolderName, setBankAccountHolderName] = useState('');
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [bankIfsc, setBankIfsc] = useState('');

    // Company
    const [companyName, setCompanyName] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [rateType, setRateType] = useState<{ label: string, value: string }|null>(null);
    const [rateTypeOptions, setRateTypeOptions] = useState<{ label: string, value: string }[]>([]);

    // Extra
    const [notes, setNotes] = useState('');
    const [discount, setDiscount] = useState(0);
    const [tcs, setTcs] = useState(false);
    const [tds, setTds] = useState(false);

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        if (name === '' || phoneNumber === '') {
            toast.error('Please fill all required fields');
            return;
        }

        if (bankName !== '' && (bankBranch === '' || bankAccountHolderName === '' || bankAccountNumber === '' || bankIfsc === '')) {
            toast.error('Please fill all bank related fields or leave all blank');
            return;
        }

        if (companyName !== '' && (gstNumber === '')) {
            toast.error('Please fill all company related fields or leave all blank');
            return;
        }

        if (billingAddressName !== '' && (billingAddressLine1 === '' || billingAddressCountry == null || billingAddressState == null || billingAddressCity == null || billingAddressZipcode === '')) {
            toast.error('Please fill all billing address related fields or leave all blank');
            return;
        }

        if (shippingAddressName !== '' && (shippingAddressLine1 === '' || shippingAddressCountry == null || shippingAddressState == null || shippingAddressCity == null || shippingAddressZipcode === '')) {
            toast.error('Please fill all shipping address related fields or leave all blank');
            return;
        }

        toast.loading('Updating customer...');

        const addresses = [];
        if (shippingAddressName !== '') {
            addresses.push({
                name: shippingAddressName,
                ...(shippingAddressLine1 !== '' && {addressLine1: shippingAddressLine1}),
                ...(shippingAddressLine2 !== '' && {addressLine2: shippingAddressLine2}),
                ...(shippingAddressCountry !== null && {country: shippingAddressCountry.label}),
                ...(shippingAddressState !== null && {state: shippingAddressState.label}),
                ...(shippingAddressCity !== null && {city: shippingAddressCity.label}),
                ...(shippingAddressZipcode !== '' && {zipCode: shippingAddressZipcode}),
                type: 'Shipping',
            });
        }
        if (billingAddressName !== '') {
            addresses.push({
                name: billingAddressName,
                ...(billingAddressLine1 !== '' && {addressLine1: billingAddressLine1}),
                ...(billingAddressLine2 !== '' && {addressLine2: billingAddressLine2}),
                ...(billingAddressCountry && {country: billingAddressCountry.label}),
                ...(billingAddressState && {state: billingAddressState.label}),
                ...(billingAddressCity && {city: billingAddressCity.label}),
                ...(billingAddressZipcode !== '' && {zipCode: billingAddressZipcode}),
                type: 'Billing',
            });
        }
        const data = {
            type,
            name,
            email,
            phoneNumber,
            ...(whatsapp !== '' && {whatsapp}),
            ...(website !== '' && {website}),
            ...(profilePic !== '' && {profilePic}),
            addresses,
            ...(bankName !== '' && {
                bank: {
                    name: bankName,
                    ...(bankBranch !== '' && {branch: bankBranch}),
                    ...(bankAccountHolderName !== '' && {accountHolder: bankAccountHolderName}),
                    ...(bankAccountNumber !== '' && {accountNumber: bankAccountNumber}),
                    ...(bankIfsc !== '' && {ifscCode: bankIfsc}),
                }
            }),
            ...(companyName !== '' && {
                company: {
                    name: companyName,
                    ...(gstNumber !== '' && {gstNumber}),
                    ...(rateType !== null && {rateType: rateType.value}),
                }
            }),
            extra: {
                ...(notes !== '' && {notes}),
                discount,
                tcs,
                tds,
            }
        };

        const res = await service.update(parseInt(id ?? '0'), data);
        if (res) {
            toast.success('Customer updated successfully');
        }
    }

    const handleImageChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            toast.loading('Uploading image...');
            uploadService.upload(file).then((res) => {
                toast.dismiss();
                if (res.length > 0) {
                    setProfilePic(res[0]);
                    toast.success('Logo uploaded successfully');
                }
            });
        }
    };

    const loadDetails = async () => {
        service.get(parseInt(id ?? '0')).then((res: any) => {
            if (res) {
                setName(res.name);
                setEmail(res.email);
                setPhoneNumber(res.phoneNumber);
                setWhatsapp(res.whatsapp);
                setWebsite(res.website);
                setProfilePic(res.profilePic);
                if (res.addresses.length > 0) {
                    const shippingAddress = res.addresses.find((item: any) => item.type === 'Shipping');
                    if (shippingAddress !== undefined) {
                        setShippingAddressName(shippingAddress.name);
                        setShippingAddressLine1(shippingAddress.addressLine1);
                        setShippingAddressLine2(shippingAddress.addressLine2);
                        setShippingAddressZipcode(shippingAddress.zipCode);
                        // Get country, state, city
                        const countries = Country.getAllCountries();
                        const country = countries.find((item) => item.name === shippingAddress.country);
                        if (country !== undefined) {
                            setShippingAddressCountry({
                                label: country.name,
                                value: country.isoCode,
                            });
                            const states = State.getStatesOfCountry(country.isoCode);
                            const state = states.find((item) => item.name === shippingAddress.state);
                            if (state !== undefined) {
                                setShippingAddressState({
                                    label: state.name,
                                    value: state.isoCode,
                                });
                                const cities = City.getCitiesOfState(country.isoCode, state.isoCode);
                                const city = cities.find((item) => item.name === shippingAddress.city);
                                if (city !== undefined) {
                                    setShippingAddressCity({
                                        label: city.name,
                                        value: city.name,
                                    });
                                }
                            }
                        }
                    }
                    const billingAddress = res.addresses.find((item: any) => item.type === 'Billing');
                    if (billingAddress !== undefined) {
                        setBillingAddressName(billingAddress.name);
                        setBillingAddressLine1(billingAddress.addressLine1);
                        setBillingAddressLine2(billingAddress.addressLine2);
                        setBillingAddressZipcode(billingAddress.zipCode);
                        // Get country, state, city
                        const countries = Country.getAllCountries();
                        const country = countries.find((item) => item.name === billingAddress.country);
                        if (country !== undefined) {
                            setBillingAddressCountry({
                                label: country.name,
                                value: country.isoCode,
                            });
                            const states = State.getStatesOfCountry(country.isoCode);
                            const state = states.find((item) => item.name === billingAddress.state);
                            if (state !== undefined) {
                                setBillingAddressState({
                                    label: state.name,
                                    value: state.isoCode,
                                });
                                const cities = City.getCitiesOfState(country.isoCode, state.isoCode);
                                const city = cities.find((item) => item.name === billingAddress.city);
                                if (city !== undefined) {
                                    setBillingAddressCity({
                                        label: city.name,
                                        value: city.name,
                                    });
                                }
                            }
                        }
                    }
                }
                if (res.bank) {
                    setBankName(res.bank.name);
                    setBankBranch(res.bank.branch);
                    setBankAccountHolderName(res.bank.accountHolder);
                    setBankAccountNumber(res.bank.accountNumber);
                    setBankIfsc(res.bank.ifscCode);
                }
                if (res.company) {
                    setCompanyName(res.company.name);
                    setGstNumber(res.company.gstNumber);
                    if (res.company.rateType) {
                        setRateType({
                            label: res.company.rateType.type,
                            value: res.company.rateType.id,
                        });
                    }
                }
                if (res.extra) {
                    setNotes(res.extra.notes);
                    setDiscount(res.extra.discount);
                    setTcs(res.extra.tcs);
                    setTds(res.extra.tds);
                }
            }
        });
    }

    useEffect(() => {
        if (id === undefined) {
            return;
        }
        loadDetails();
    }, [id]);

    useEffect(() => {
        settingService.allRateTypes().then((res: any) => {
            if (res.length > 0) {
                const options = res.map((item: any) => {
                    return {
                        label: item.type,
                        value: item.id,
                    };
                });
                setRateTypeOptions(options);
            }
        });
    }, []);

    useEffect(() => {
        const countries = Country.getAllCountries();
        const countryOptions = countries.map((country) => {
            return {
                label: country.name,
                value: country.isoCode,
            };
        });
        setCountryOptions(countryOptions);
    }, []);

    useEffect(() => {
        if (shippingAddressCountry !== null) {
            const states = State.getStatesOfCountry(shippingAddressCountry.value);
            const stateOptions = states.map((state) => {
                return {
                    label: state.name,
                    value: state.isoCode,
                };
            });
            setShippingAddressStateOptions(stateOptions);
        }
    }, [shippingAddressCountry]);

    useEffect(() => {
        if (shippingAddressState !== null && shippingAddressCountry != null) {
            const cities = City.getCitiesOfState(shippingAddressCountry.value, shippingAddressState.value);
            const cityOptions = cities.map((city) => {
                return {
                    label: city.name,
                    value: city.name,
                };
            });
            setShippingAddressCityOptions(cityOptions);
        }
    }, [shippingAddressState]);

    useEffect(() => {
        if (billingAddressCountry !== null) {
            const states = State.getStatesOfCountry(billingAddressCountry.value);
            const stateOptions = states.map((state) => {
                return {
                    label: state.name,
                    value: state.isoCode,
                };
            });
            setBillingAddressStateOptions(stateOptions);
        }
    }, [billingAddressCountry]);

    useEffect(() => {
        if (billingAddressState !== null && billingAddressCountry != null) {
            const cities = City.getCitiesOfState(billingAddressCountry.value, billingAddressState.value);
            const cityOptions = cities.map((city) => {
                return {
                    label: city.name,
                    value: city.name,
                };
            });
            setBillingAddressCityOptions(cityOptions);
        }
    }, [billingAddressState]);

    useEffect(() => {
        if (window.location.pathname.includes('customers')) {
            setType('Customer');
        } else if (window.location.pathname.includes('vendors')) {
            setType('Vendor');
        } else if (window.location.pathname.includes('transporters')) {
            setType('Transporter');
        }
    }, [window.location.pathname]);

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Update {type}</h5>
                        </div>
                    </div>
                    {/* /Page Header */}
                    <div className="row">
                        <div className="col-md-12">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group-item">
                                    <h5 className="form-title">Basic Details</h5>
                                    <div className="profile-picture">
                                        <div className="upload-profile me-2">
                                            <div className="profile-img">
                                                <img
                                                    id="blah"
                                                    className="avatar"
                                                    src={profilePic !== '' ? profilePic : `https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${name.length > 0 ? name : 'Company Name'}&size=40&rounded=true`}
                                                    alt="profile-img"
                                                />
                                            </div>
                                        </div>
                                        <div className="img-upload">
                                            <label className="btn btn-primary">
                                                Upload new profile picture <input type="file"
                                                                                  onChange={handleImageChange}/>
                                            </label>
                                            <p className="mt-1">
                                                Image Should be minimum 152 * 152 Supported File format JPG,PNG.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>
                                                    Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>
                                                    Email
                                                </label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    placeholder="Enter Email Address"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>
                                                    Phone <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="mobile_code"
                                                    className="form-control"
                                                    placeholder="Phone Number"
                                                    value={phoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Website</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Website Address"
                                                    value={website}
                                                    onChange={(e) => setWebsite(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Whatsapp Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Whatsapp Number"
                                                    value={whatsapp}
                                                    onChange={(e) => setWhatsapp(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group-item">
                                    <div className="row align-items-end">
                                        <div className="col-md-6">
                                            <div className="billing-btn mb-2">
                                                <h5 className="form-title">Billing Address</h5>
                                            </div>
                                            <div className="input-block mb-3">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    value={billingAddressName}
                                                    onChange={(e) => setBillingAddressName(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-block mb-3">
                                                <label>Address Line 1</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Address 1"
                                                    value={billingAddressLine1}
                                                    onChange={(e) => setBillingAddressLine1(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-block mb-3">
                                                <label>Address Line 2</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Address 2"
                                                    value={billingAddressLine2}
                                                    onChange={(e) => setBillingAddressLine2(e.target.value)}
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>Country</label>
                                                        <Select
                                                            name="country"
                                                            options={countryOptions}
                                                            value={billingAddressCountry}
                                                            onChange={setBillingAddressCountry}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>State</label>
                                                        <Select
                                                            name="state"
                                                            options={billingAddressStateOptions}
                                                            value={billingAddressState}
                                                            onChange={setBillingAddressState}/>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>City</label>
                                                        <Select
                                                            name="state"
                                                            options={billingAddressCityOptions}
                                                            value={billingAddressCity}
                                                            onChange={setBillingAddressCity}/>
                                                    </div>

                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>PinCode</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Pincode"
                                                            value={billingAddressZipcode}
                                                            onChange={(e) => setBillingAddressZipcode(e.target.value)}
                                                        />
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="billing-btn">
                                                <h5 className="form-title mb-0">Shipping Address</h5>
                                                <a href="javascript:void(0)" onClick={() => {
                                                    setShippingAddressName(billingAddressName);
                                                    setShippingAddressLine1(billingAddressLine1);
                                                    setShippingAddressLine2(billingAddressLine2);
                                                    setShippingAddressCountry(billingAddressCountry);
                                                    setShippingAddressState(billingAddressState);
                                                    setShippingAddressCity(billingAddressCity);
                                                    setShippingAddressZipcode(billingAddressZipcode);
                                                }} className="btn btn-primary bg-primary">
                                                    Copy from Billing
                                                </a>
                                            </div>
                                            <div className="input-block mb-3">
                                                <label>Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Name"
                                                    value={shippingAddressName}
                                                    onChange={(e) => setShippingAddressName(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-block mb-3">
                                                <label>Address Line 1</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Address 1"
                                                    value={shippingAddressLine1}
                                                    onChange={(e) => setShippingAddressLine1(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-block mb-3">
                                                <label>Address Line 2</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Address 2"
                                                    value={shippingAddressLine2}
                                                    onChange={(e) => setShippingAddressLine2(e.target.value)}
                                                />
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>Country</label>
                                                        <Select
                                                            name="country"
                                                            options={countryOptions}
                                                            value={shippingAddressCountry}
                                                            onChange={setShippingAddressCountry}/>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>State</label>
                                                        <Select
                                                            name="state"
                                                            options={shippingAddressStateOptions}
                                                            value={shippingAddressState}
                                                            onChange={setShippingAddressState}/>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>City</label>
                                                        <Select
                                                            name="state"
                                                            options={shippingAddressCityOptions}
                                                            value={shippingAddressCity}
                                                            onChange={setShippingAddressCity}/>
                                                    </div>

                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>PinCode</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Pincode"
                                                            value={shippingAddressZipcode}
                                                            onChange={(e) => setShippingAddressZipcode(e.target.value)}
                                                        />
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group-customer customer-additional-form">
                                    <div className="row">
                                        <h5 className="form-title">Bank Details</h5>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Bank Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Bank Name"
                                                    value={bankName}
                                                    onChange={(e) => setBankName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Branch</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Branch Name"
                                                    value={bankBranch}
                                                    onChange={(e) => setBankBranch(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Account Holder Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Account Holder Name"
                                                    value={bankAccountHolderName}
                                                    onChange={(e) => setBankAccountHolderName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Account Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Account Number"
                                                    value={bankAccountNumber}
                                                    onChange={(e) => setBankAccountNumber(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>IFSC</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter IFSC Code"
                                                    value={bankIfsc}
                                                    onChange={(e) => setBankIfsc(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group-customer customer-additional-form">
                                    <div className="row">
                                        <h5 className="form-title">Company Details</h5>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Company Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Company Name"
                                                    value={companyName}
                                                    onChange={(e) => setCompanyName(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>GST Number</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter GST Number"
                                                    value={gstNumber}
                                                    onChange={(e) => setGstNumber(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                            <label htmlFor="type" className="form-label">Rate Type</label>
                                            <Select
                                                name="permission"
                                                options={rateTypeOptions}
                                                value={rateType}
                                                onChange={setRateType}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group-customer customer-additional-form">
                                    <div className="row">
                                        <h5 className="form-title">Additional Details</h5>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Discount</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Discount"
                                                    value={discount}
                                                    onChange={(e) => setDiscount(parseInt(e.target.value))}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                            <div className="input-block mb-3">
                                                <label>Notes</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter notes"
                                                    value={notes}
                                                    onChange={(e) => setNotes(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="input-block mb-3">
                                                <div className="mail-provider">
                                                    <h4>TCS</h4>
                                                    <div className="mail-setting">
                                                        <div className="status-toggle">
                                                            <input
                                                                id="tcs"
                                                                className="check"
                                                                name="tcs"
                                                                type="checkbox"
                                                                checked={tcs}
                                                                onChange={(e) => setTcs(e.target.checked)}
                                                            />
                                                            <label htmlFor="tcs" className="checktoggle checkbox-bg">
                                                                checkbox
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12">
                                            <div className="input-block mb-3">
                                                <div className="mail-provider">
                                                    <h4>TDS</h4>
                                                    <div className="mail-setting">
                                                        <div className="status-toggle">
                                                            <input
                                                                id="tds"
                                                                className="check"
                                                                type="checkbox"
                                                                checked={tds}
                                                                name={'tds'}
                                                                onChange={(e) => setTds(e.target.checked)}
                                                            />
                                                            <label htmlFor="tds" className="checktoggle checkbox-bg">
                                                                checkbox
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-path text-end">
                                    <button onClick={() => {
                                        loadDetails();
                                    }} className="btn btn-cancel bg-primary-light me-3">
                                        Cancel
                                    </button>
                                    <button type="submit" className="btn btn-primary">
                                        Save Changes
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default UpdateCustomer;
